/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var RadioMixin = require('ES/utils/RadioMixin');
var esUtils = require('ES/utils/esUtils');

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState: function(){
		return {confirmMode: false, deleting: false, error_msg: null};
	},
	componentWillMount: function(){
		var self = this;
		self.radio = {
			'Event_destroy_failed': function(event_id, message){
				if(self.props.event && self.props.event.eid == event_id){
					self.setState({deleting: false, error_msg: 'Failed to delete event: ' + message});
				}
			}
		};
	},
	__toggleConfirmMode: esUtils.wrapPreventDefault(function(){
		this.setState({confirmMode: !this.state.confirmMode});
	}),
	__resetState: esUtils.wrapPreventDefault(function(){
		this.setState({confirmMode: false, deleting: false, error_msg: null});
	}),
	__delete: esUtils.wrapPreventDefault(function(){
		var event_id = _.parseInt(this.props.event && this.props.event.eid);
		if(_.isNaN(event_id) || event_id < 1){
			return;
		}
		radio('Event_destroy').broadcast(event_id);
		this.setState({deleting: true});
	}),
	render: function(){
		var event = this.props.event;

		if(event.is_mp_event){
			return dd.div(null);
		}
		if(!this.state.confirmMode && !this.state.deleting){
			return dd.button({className: 'btn btn-default', onClick: this.__toggleConfirmMode}, 'Delete event');
		}
		var body = null;
		if(this.state.error_msg){
			body = dd.div(null,
				dd.a({href: '#', className: 'pull-right', onClick: this.__resetState}, 'close'),
				this.state.error_msg
			);
		}else if(this.state.deleting){
			body = dd.div({className: 'text-center'},
				dd.b(null, 'Deleting...')
			);
		}else{
			body = dd.div({className: ''},
				dd.p(null,
					dd.b(null, 'Are you sure?'), ' DELETE is going to remove this event, "' + event.organization + '," ', dd.b(null, 'permanently. '),
					'A better option is to change the status to Canceled/Released so that the data can be retrieved.'
				),
				dd.button({className: 'btn btn-danger', onClick: this.__delete}, 'Yes, Delete'),
				' ',
				dd.button({className: 'btn btn-default', onClick: this.__toggleConfirmMode}, 'No, don\'t delete')
			);
		}
		return dd.div({className: 'alert alert-danger', style: {marginBottom: 0}},
			body
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/event_actions/DeleteEvent.js